import styled from "styled-components";

export const StyledTextError = styled.div`
  color: var(--error-500);
  /* width: 404px; */
  display: flex;
  align-items: center;
  text-align: right;
  font-weight: 400;
  font-size: 10px;
  /* line-height: 17px; */
  direction: rtl;
  margin-top: 5px;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  width: 100%;
  & svg {
    width: 14.33px;
    height: 14.33px;
    margin-left: 4.83px;
  }
`;
